"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalAlert = exports.error = exports.success = exports.alert = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var ModalMain_1 = require("./ModalMain");
var button_1 = require("../button");
var ModalMessage_1 = require("./ModalMessage");
var call_both_1 = require("../_util/call-both");
var i18n_1 = require("../i18n");
var merge_refs_1 = require("../_util/merge-refs");
var configprovider_1 = require("../configprovider");
var noop_1 = require("../_util/noop");
/**
 * API 的方式唤起一个告警对话框
 * @param options
 */
function alert(options) {
    var _a = options.onExited, onExited = _a === void 0 ? noop_1.noop : _a, restOptions = tslib_1.__rest(options, ["onExited"]);
    return new Promise(function (resolve) {
        var el = document.createElement("div");
        react_dom_1.default.render(react_1.default.createElement(configprovider_1.ConfigProvider, null,
            react_1.default.createElement(ModalAlertAPI, tslib_1.__assign({}, restOptions, { onButtonClick: function () { return resolve(); }, onExited: function () {
                    onExited();
                    react_dom_1.default.unmountComponentAtNode(el);
                } }))), el);
    });
}
exports.alert = alert;
/**
 * API 的方式唤起一个对话框显示成功信息
 */
function success(options) {
    return alert(tslib_1.__assign({ type: "success" }, options));
}
exports.success = success;
/**
 * API 的方式唤起一个对话框显示失败信息
 */
function error(options) {
    return alert(tslib_1.__assign({ type: "error" }, options));
}
exports.error = error;
function ModalAlertAPI(_a) {
    var onButtonClick = _a.onButtonClick, _b = _a.onClose, onClose = _b === void 0 ? noop_1.noop : _b, modalProps = tslib_1.__rest(_a, ["onButtonClick", "onClose"]);
    var _c = tslib_1.__read(react_1.useState(false), 2), visible = _c[0], setVisible = _c[1];
    // 渲染之后，马上显示
    react_1.useEffect(function () { return setVisible(true); }, []);
    var close = function () {
        onClose();
        setVisible(false);
        onButtonClick();
    };
    return (react_1.default.createElement(ModalAlert, tslib_1.__assign({ visible: visible, onButtonClick: close, onClose: close }, modalProps)));
}
/**
 * 提供原始的 ModalAlert 组件。
 * 推荐使用 `Modal.success()` / `Modal.error()` API 来简化用法
 */
function ModalAlert(_a) {
    var type = _a.type, message = _a.message, description = _a.description, modalProps = tslib_1.__rest(_a, ["type", "message", "description"]);
    react_1.useEffect(function () {
        window.focus();
    }, []);
    return (react_1.default.createElement(ModalMain_1.Modal, tslib_1.__assign({ maskClosable: true }, modalProps),
        react_1.default.createElement(ModalMain_1.Modal.Body, null,
            react_1.default.createElement(ModalMessage_1.ModalMessage, { icon: type, message: message, description: description })),
        react_1.default.createElement(ModalMain_1.Modal.Footer, null,
            react_1.default.createElement(ModalButton, tslib_1.__assign({}, modalProps)))));
}
exports.ModalAlert = ModalAlert;
function ModalButton(_a) {
    var buttons = _a.buttons, buttonText = _a.buttonText, onButtonClick = _a.onButtonClick;
    var t = i18n_1.useTranslation();
    var mainButtonRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (mainButtonRef.current) {
            mainButtonRef.current.focus();
        }
    }, []);
    var okText = buttonText !== null && buttonText !== void 0 ? buttonText : t.okText;
    return (react_1.default.createElement(react_1.default.Fragment, null, (buttons || [
        react_1.default.createElement(button_1.Button, { type: "primary", htmlType: "button" }, okText),
    ]).map(function (button, index) {
        return react_1.default.cloneElement(button, {
            key: index,
            onClick: call_both_1.callBoth(button.props.onClick, onButtonClick),
            ref: index === 0
                ? merge_refs_1.mergeRefs(button.props.ref, mainButtonRef)
                : button.props.ref,
        });
    })));
}
//# sourceMappingURL=ModalAlert.js.map